var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-marker",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.202,
    height: 42.529,
    viewBox: "0 0 30.202 42.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "map-marker-solid",
    d: "M13.549,41.671C2.121,24.174,0,22.379,0,15.948,0,7.14,6.761,0,15.1,0S30.2,7.14,30.2,15.948c0,6.43-2.121,8.226-13.549,25.723A1.832,1.832,0,0,1,13.549,41.671Z",
    fill: "#bc0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarker);
export default __webpack_public_path__ + "static/media/ic-marker.315f7f37d6a4d494926464cc0c9b4df4.svg";
export { ForwardRef as ReactComponent };